import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlowFileUploaderComponent } from './flow-file-uploader.component';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatIconModule } from '@angular/material/icon';
import { CtFileUploaderModule } from '@ctsolution/ct-framework';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

@NgModule({
  declarations: [FlowFileUploaderComponent],
  imports: [CommonModule, MatCardModule, MatIconModule, CtFileUploaderModule, MatButtonModule],
  exports: [FlowFileUploaderComponent],
})
export class FlowFileUploaderModule {}
